/** Why a pending merge request went "outdated" (merge_requests.status_reason). */
export type OutdatedReason = "target_moved" | "source_reset_to_draft" | "source_reset" | "source_moved";

/** The banner text for an outdated request. target_moved: the target's
 *  head moved after the request was filed (another request merged, a direct
 *  merge, a rebase applied to it, a reset or a force push). Requests
 *  outdated before the reason was recorded (null) were outdated by a merge
 *  into the target. */
export function outdatedReasonText(
  reason: string | null | undefined,
  sourceBranchName: string,
  targetBranchName: string,
): string {
  switch (reason) {
    case "source_reset_to_draft":
      return `Previous merge request was outdated because ${sourceBranchName} was reset to drafts, so the commits it reviewed are gone. Commit the changes and submit a new request.`;
    case "source_reset":
      return `Previous merge request was outdated because ${sourceBranchName} was reset past the commits it reviewed. Commit the changes and submit a new request.`;
    case "source_moved":
      return `Previous merge request was outdated because ${sourceBranchName} was moved to a commit without the reviewed changes. Submit a new request.`;
    case "target_moved":
      return `Previous merge request was outdated because ${targetBranchName} changed after it was filed (a merge into it, a reset or a force push). Rebase and submit a new request.`;
    default:
      return `Previous merge request was outdated because another branch was merged into ${targetBranchName}. Rebase and submit a new request.`;
  }
}
